import gql from "graphql-tag";

// eslint-disable-next-line no-restricted-imports -- TODO(FEI-7051): switch to useGql
import type {ApolloGqlClient, ApolloResult} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {
    resendVerificationEmailType,
    signupResendVerificationEmailMutationType,
} from "./__graphql-types__/index.ts";

const RESEND_VERIFICATION_EMAIL_MUTATION: GqlOperation<
    resendVerificationEmailType["response"],
    resendVerificationEmailType["variables"]
> = gqlOp(gql`
    mutation resendVerificationEmail($token: String!) {
        resendVerificationEmail(token: $token) {
            error {
                code
            }
        }
    }
`);

export function resendVerificationEmail(
    gqlClient: ApolloGqlClient,
    token: string,
): Promise<ApolloResult<resendVerificationEmailType["response"]>> {
    const variables = {token} as const;
    return gqlClient
        .mutate(RESEND_VERIFICATION_EMAIL_MUTATION, {
            variables,
        })
        .then((r) => {
            if (r.data?.resendVerificationEmail?.error) {
                throw new KAError(
                    r.data.resendVerificationEmail.error.code,
                    Errors.Internal,
                );
            }

            return r;
        })
        .catch((e) => {
            throw new KAError(
                "Failed to resend verification email",
                Errors.Internal,
                {cause: e},
            );
        });
}

export const SIGNUP_RESEND_VERIFICATION_EMAIL_MUTATION: GqlOperation<
    signupResendVerificationEmailMutationType["response"],
    signupResendVerificationEmailMutationType["variables"]
> = gqlOp(gql`
    mutation signupResendVerificationEmailMutation {
        signupResendVerificationEmail {
            error {
                code
            }
        }
    }
`);

export async function signupResendVerificationEmail(
    gqlClient: ApolloGqlClient,
): Promise<boolean> {
    try {
        const result = await gqlClient.mutate(
            SIGNUP_RESEND_VERIFICATION_EMAIL_MUTATION,
        );

        if (result.data?.signupResendVerificationEmail?.error) {
            throw new KAError(
                result.data.signupResendVerificationEmail.error.code,
                Errors.Internal,
            );
        }

        // Verification email sent.
        return true;
    } catch (error: any) {
        // We handle the exception thrown from within the mutation success
        // handler.
        if (error instanceof KAError) {
            throw error;
        }

        // Otherwise we throw a generic error.
        throw new KAError(
            "Failed to resend the verification email",
            Errors.Internal,
        );
    }
}
